<template>
    <div>
        <multiselect v-model="template" :options="chatTemplates" selectedLabel="ausgewählt"
                     selectLabel="Klicken zum Hinzufügen" deselectLabel="Klicken zum Entfernen"
                     placeholder="Vorlage auswählen" label="title" @select="changeMessage" @remove="deleteMessage"
                     :close-on-select="true"
                     track-by="id"></multiselect>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'

    export default {
        components: {Multiselect},
        props: ['chatTemplates'],
        data() {
            return {
                template: null,
            }
        },
        methods: {
            changeMessage: function (selectedOption, id) {
                this.$emit('update-message', selectedOption.text)
            },
            deleteMessage: function () {
                this.$emit('update-message', "")
            }
        },
    }
</script>

<style scoped lang="scss">
.multiselect--active {
  min-height: 200px;
}
.multiselect__content-wrapper {
  min-height: 200px;
}
</style>
